import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MailToStore {

}

export enum MailToStoreKeys {

}
